export default "__VITE_ASSET__rmZAEonO__"